import React from "react";
import Accordion from "react-bootstrap-v1.6/Accordion";
import classNames from "classnames";

import styles from "./main.module.scss";

const AccordionAllCollapsable = ({
  id = "",
  eventKey = "",
  toggleValue = "",
  isOpen = false,
  expandedId = "",
  handleAccordianToggle,
  titleContent,
  bodyContent,
  accordionCustomClass = "",
  headerCustomClass = "",
  collapseCustomClass = "",
  alwaysRenderChild = false,
}) => {
  let bodyToRender = isOpen ? <>{bodyContent}</> : <></>;
  if (alwaysRenderChild) {
    bodyToRender = (
      <span className={classNames({ [styles.hideBody]: !isOpen })}>{bodyContent}</span>
    );
  }

  return (
    <Accordion
      key={id}
      className={`${accordionCustomClass} accordion ${accordionCustomClass} ${
        isOpen ? "accordion-open" : "accordion-closed"
      }`}
      activeKey={expandedId}
    >
      <Accordion.Toggle
        variant="link"
        eventKey={eventKey}
        className={`card-header ${styles.accordionHeader} ${headerCustomClass}`}
        onClick={() => handleAccordianToggle(isOpen ? null : toggleValue)}
      >
        {titleContent}
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey} className={collapseCustomClass}>
        {bodyToRender}
      </Accordion.Collapse>
    </Accordion>
  );
};
export default AccordionAllCollapsable;
